module.exports = __webpack_public_path__ + "img/yawning_face.14ca1482.gif";